<template>
  <a-config-provider :getPopupContainer="getPopupContainer">
    <div>
      <a-modal
        v-bind="attrs"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        :centered="true"
        width="800px"
        ok-text="保存"
        @cancel="cancel"
      >
        <div class="flex-b mt-10">
          <div class="flex-s">
            <img :src="autoInfo.workflowIcon" class="auto-header-icon wd30 ht30" />
            <div>{{ autoInfo.workflowName }}</div>
          </div>
          <div class="dropdown-item flex-s">
            <a-tooltip placement="top">
              <template #title>
                <span>关闭后当前运行计划将不会再自动运行</span>
              </template>
              <component :is="icons['QuestionCircleOutlined']" class="mr-8" />
            </a-tooltip>
            <span class="pr-8">开/关</span>
            <a-switch v-model:checked="checkedVal" checked-children="开" un-checked-children="关" />
          </div>
        </div>

        <div class="frequency-form">
          <div class="flex-s fs-16 fw-7">
            <div class="icon-bg wd36 ht36 flex mr-10">
              <img
                src="@/assets/images/script/ThunderboltOutlined.png"
                class="wd20"
                style="vertical-align: middle"
              />
            </div>
            <span>运行计划</span>
          </div>
          <div class="fs-12 mt-4" style="color: #333333">制定运行计划工作流按照计划自动运行</div>
          <a-form
            :model="states"
            name="addWorkflow"
            ref="formRef"
            layout="vertical"
            :rules="rules"
            autocomplete="off"
            class="mt-20 mb-20"
          >
            <a-form-item label="计划名称" name="taskName">
              <a-input v-model:value="states.taskName"> </a-input>
            </a-form-item>
          </a-form>
          <div style="overflow-y: auto; max-height: 180px">
            <div class="form flex-b" v-for="(item, index) in states.formState" :key="index">
              <a-button
                shape="circle"
                danger
                type="text"
                class="mr-10"
                @click="deleteFrequency(index)"
                v-if="states.formState.length > 1"
              >
                <component :is="icons['DeleteOutlined']" />
              </a-button>
              <div class="flex-s flex-1">
                <span class="pr-4">每</span>
                <a-select
                  v-model:value="item.frequency"
                  :options="optionsFrequency"
                  style="width: 100px"
                  @change="frequencyChange($event, index)"
                ></a-select>
                <template v-if="item.frequency == 'year'">
                  <div>
                    <span class="pl-4 pr-4">的</span>
                    <a-select
                      v-model:value="item.month"
                      :options="optionsMonth"
                      style="width: 100px"
                    ></a-select>
                  </div>
                  <div>
                    <span class="pl-4 pr-4">份的第</span>
                    <a-select
                      v-model:value="item.day"
                      :options="optionsDay"
                      style="width: 100px"
                    ></a-select>
                  </div>
                  <div>
                    <span class="pl-4 pr-4">天，时间为</span>
                    <a-time-picker v-model:value="item.time" valueFormat="HH:mm:ss" />
                  </div>
                </template>
                <template v-if="item.frequency == 'month'">
                  <div>
                    <span class="pl-4 pr-4">的第</span>
                    <a-select
                      v-model:value="item.day"
                      :options="optionsDay"
                      style="width: 100px"
                    ></a-select>
                  </div>
                  <div>
                    <span class="pl-4 pr-4">天，时间为</span>
                    <a-time-picker v-model:value="item.time" valueFormat="HH:mm:ss" />
                  </div>
                </template>
                <template v-if="item.frequency == 'week'">
                  <div>
                    <span class="pl-4 pr-4">的</span>
                    <a-select
                      v-model:value="item.week"
                      :options="optionsWeek"
                      style="width: 100px"
                    ></a-select>
                  </div>
                  <div>
                    <span class="pl-4 pr-4">，时间为</span>
                    <a-time-picker v-model:value="item.time" valueFormat="HH:mm:ss" />
                  </div>
                </template>
                <template v-if="item.frequency == 'day'">
                  <div>
                    <span class="pl-4 pr-4">的</span>
                    <a-time-picker v-model:value="item.time" valueFormat="HH:mm:ss" />
                  </div>
                </template>
              </div>
            </div>
          </div>
          <a-button type="dashed" class="mt-10" block @click="addFrequency">
            <component :is="icons['PlusOutlined']" />
            运行计划
          </a-button>
        </div>
      </a-modal>
    </div>
  </a-config-provider>
</template>

<script setup>
import {
  Modal as AModal,
  Button as AButton,
  Select as ASelect,
  TimePicker as ATimePicker,
  Switch as ASwitch,
  Form as AForm,
  Input as AInput,
  Tooltip as ATooltip,
  ConfigProvider as AConfigProvider,
  message
} from 'ant-design-vue'
import { ref, reactive, useAttrs, getCurrentInstance, watch } from 'vue'
import * as icons from '@ant-design/icons-vue'
import { addAutoRunningFrequencyApi, getAutoRunningFrequencyApi } from '@/service/api/script.js'
import { scriptStore } from '@/store/scriptStore'
import { cloneDeep } from 'lodash'

const AFormItem = AForm.Item

const emits = defineEmits(['asyncSuccess'])
const store = scriptStore()
const { proxy } = getCurrentInstance()
const attrs = useAttrs()
let autoInfo = reactive({})
const states = reactive({
  taskName: '',
  formState: [
    {
      frequency: '',
      month: '',
      day: '',
      week: '',
      time: ''
    }
  ]
})
const confirmLoading = ref(false)
const checkedVal = ref(true)
const formRef = ref(null)
const optionsMonth = ref([])
const optionsDay = ref([])
const optionsWeek = ref([
  { value: '1', label: '周一' },
  { value: '2', label: '周二' },
  { value: '3', label: '周三' },
  { value: '4', label: '周四' },
  { value: '5', label: '周五' },
  { value: '6', label: '周六' },
  { value: '0', label: '周日' }
])
const rules = {
  taskName: [
    {
      required: true,
      message: '不能为空',
      trigger: ['change', 'blur']
    },
    {
      max: 8,
      message: '长度不可超过8个字符',
      trigger: ['change', 'blur']
    }
  ]
}
for (let i = 1; i < 13; i++) {
  optionsMonth.value.push({
    value: i,
    label: `${i}月`
  })
}
for (let i = 1; i < 32; i++) {
  optionsDay.value.push({
    value: i,
    label: i
  })
}
const optionsFrequency = ref([
  {
    value: 'year',
    label: '年'
  },
  {
    value: 'month',
    label: '月'
  },
  {
    value: 'week',
    label: '周'
  },
  {
    value: 'day',
    label: '天'
  }
])

const addFrequency = () => {
  if (states.formState.length >= 8) return message.error('最多添加八个运行计划')
  states.formState.push({
    frequency: '',
    month: '',
    day: '',
    week: '',
    time: ''
  })
}
const getPopupContainer = (el, dialogContext) => {
  if (dialogContext) {
    return dialogContext.getDialogWrap()
  } else {
    return document.body
  }
}
const frequencyChange = (val, index) => {
  console.log(val)
  states.formState[index] = {
    frequency: val,
    month: '',
    day: '',
    week: '',
    time: ''
  }
}
const deleteFrequency = (index) => {
  states.formState.splice(index, 1)
}
const cancel = () => {
  states.formState = [
    {
      frequency: '',
      month: '',
      day: '',
      week: '',
      time: ''
    }
  ]
}
const handleOk = () => {
  formRef.value
    .validate()
    .then(() => {
      const valid = validateScheduleItems(states.formState)
      if (!valid) return message.error('请填写完整的运行计划')
      const cronList = states.formState.map((i) => objToCron(i))
      confirmLoading.value = true
      console.log(store.autoRunningInfo)

      addAutoRunningFrequencyApi({
        workflowInfoId: store.autoRunningInfo.workflowInfoId,
        executeEnable: checkedVal.value,
        executeCode: store.autoRunningInfo.executeCode,
        cornList: cronList,
        taskName: states.taskName,
        workflowName: store.autoRunningInfo.workflowName,
        id: store.autoRunningInfo.taskId ? store.autoRunningInfo.taskId : null
      }).then((res) => {
        if (res.data) {
          message.success('修改成功')
          cancel()
          emits('asyncSuccess')
          proxy.$EventBus.emit('autoRunningMitt')
        }
        confirmLoading.value = false
      })
    })
    .catch(() => {})
}
const objToCron = (f) => {
  let week = '?'
  let month = '*'
  let day = '*'
  const [hour, minute, second] = f.time.split(':')
  if (f.frequency === 'year') {
    month = f.month
    day = f.day
  } else if (f.frequency === 'month') {
    month = '*'
    day = f.day
  } else if (f.frequency === 'week') {
    week = f.week
  } else if (f.frequency === 'day') {
    day = '*'
  }
  return `${second} ${minute} ${hour} ${day} ${month} ${week}`
}
const cronToObj = (cronString) => {
  let frequency = ''
  let [second, minute, hour, day, month, week] = cronString.split(' ')
  if (week !== '?') {
    frequency = 'week'
  } else if (day === '*') {
    frequency = 'day'
  } else if (month === '*') {
    frequency = 'month'
  } else {
    frequency = 'year'
  }
  return {
    frequency,
    month,
    day,
    week,
    time: `${hour}:${minute}:${second}`
  }
}
const validateScheduleItems = (items) => {
  const frequencyRules = {
    year: ['month', 'day', 'time'],
    month: ['day', 'time'],
    week: ['week', 'time'],
    day: ['time']
  }

  const hasErrors = items.some((item) => {
    const requiredFields = frequencyRules[item.frequency]
    if (!requiredFields) {
      return true // 返回 true 表示有错误
    }
    const missingFields = requiredFields.some((field) => !item[field])
    if (missingFields) {
      return true // 返回 true 表示有错误
    }
    return false // 返回 false 表示没有错误
  })
  return !hasErrors // 如果没有错误，返回 true，否则返回 false
}
watch(
  () => attrs.open,
  (val) => {
    if (val) {
      if (store.autoRunningInfo.taskId) {
        getAutoRunningFrequencyApi({
          taskId: store.autoRunningInfo.taskId
        }).then((res) => {
          if (res.data) {
            Object.assign(autoInfo, res.data)
            states.formState = res.data.cornList.length
              ? res.data.cornList.map((i) => cronToObj(i))
              : [
                  {
                    frequency: '',
                    month: '',
                    day: '',
                    week: '',
                    time: ''
                  }
                ]
            states.taskName = res.data.taskName
            checkedVal.value = res.data.executeEnable
          }
        })
      }
      autoInfo = cloneDeep(store.autoRunningInfo)
    } else {
      store.autoRunningInfo = {}
      states.taskName = ''
      states.formState = [
        {
          frequency: '',
          month: '',
          day: '',
          week: '',
          time: ''
        }
      ]
      checkedVal.value = false
      confirmLoading.value = false
    }
  }
)
</script>

<style lang="less" scoped>
.auto-header-icon {
  border-radius: 4px;
  margin-right: 10px;
}
.frequency-form {
  margin-top: 20px;
  padding: 16px;
  border: 1px solid @theme-color;
  border-radius: 6px;
  .form {
    margin-bottom: 16px;
  }
}
.icon-bg {
  background-color: @workFlow-icon;
  border-radius: 50%;
}
</style>
